import type { PartialCrmMessages } from "./englishCrmMessages";

/** Auto-generated from docs/i18n/translation-matrix.csv — do not edit by hand */
export const danishCrmMessages: PartialCrmMessages = {
  crm: {
    action: {
      reset_password: "Nulstil adgangskode",
    },
    activity: {
      added_company: "%{name} tilføjede kunde",
      added_company_note: "%{name} tilføjede en note om",
      added_contact: "%{name} tilføjede",
      added_deal: "%{name} tilføjede aftale",
      added_note: "%{name} tilføjede en note om",
      added_note_about_deal: "%{name} tilføjede en note om aftale",
      at_company: "hos",
      load_more: "Indlæs mere aktivitet",
      to: "til",
      you_added_company: "Du tilføjede kunde",
      you_added_company_note: "Du tilføjede en note om",
      you_added_contact: "Du tilføjede",
      you_added_deal: "Du tilføjede aftale",
      you_added_note: "Du tilføjede en note om",
      you_added_note_about_deal: "Du tilføjede en note om aftale",
    },
    auth: {
      confirm_password: "Bekræft adgangskode",
      confirmation_required: "Følg linket i den e-mail, vi lige har sendt, for at bekræfte din konto.",
      first_name: "Fornavn",
      last_name: "Efternavn",
      recovery_email_sent: "Hvis du er registreret bruger, modtager du snart en e-mail til nulstilling af adgangskode.",
      sign_in_failed: "Kunne ikke logge ind.",
      sign_in_google_workspace: "Log ind med Google Workplace",
      signup: {
        create_account: "Opret konto",
        create_first_user: "Opret den første brugerkonto for at fuldføre opsætningen.",
        creating: "Opretter...",
        initial_user_created: "Første bruger oprettet",
      },
      welcome_title: "Velkommen til Atomic CRM",
    },
    mfa: {
      setup: {
        title: "Opsæt to-faktor-godkendelse",
        subtitle:
          "To-faktor-godkendelse er påkrævet, før du kan bruge Gobo CRM.",
        choose_totp: "Authenticator-app (anbefalet)",
        choose_sms: "SMS-besked",
        backup_hint:
          "Tip: Tilføj en backup authenticator-app i din profil, så du ikke bliver låst ude.",
      },
      verify: {
        title: "Bekræft din identitet",
        subtitle: "Indtast koden fra din authenticator-app eller SMS.",
        submit: "Bekræft",
      },
      set_password: {
        title: "Bekræft før du skifter adgangskode",
        subtitle:
          "Indtast din to-faktor-kode for at fortsætte. Dette er påkrævet, fordi MFA er aktiveret på din konto.",
      },
      settings: {
        title: "To-faktor-godkendelse",
        description:
          "Administrer dine MFA-faktorer. Vi anbefaler at beholde en backup authenticator-app.",
        none: "Ingen MFA-faktorer er opsat.",
        remove: "Fjern",
        add_factor: "Tilføj backup-faktor",
      },
      totp: {
        friendly_name: "Authenticator-app",
        description:
          "Brug Microsoft Authenticator, Google Authenticator eller en anden TOTP-app.",
        start: "Opsæt authenticator-app",
        manual_secret: "Manuel indtastningsnøgle:",
        scan_hint:
          "Scan QR-koden, og indtast derefter den 6-cifrede kode fra din app.",
      },
      sms: {
        friendly_name: "SMS",
        description:
          "Modtag engangskoder via SMS. Brug internationalt format, fx +4512345678.",
        phone: "Telefonnummer",
        send_code: "Send kode",
        code_sent: "Indtast koden, vi sendte til din telefon.",
      },
      code: "Bekræftelseskode",
      remember_device: "Husk denne enhed i 30 dage",
      verify_and_continue: "Bekræft og fortsæt",
      back: "Tilbage",
      setup_complete: "To-faktor-godkendelse er nu aktiveret.",
      enroll_error: "Kunne ikke starte MFA-opsætning. Prøv igen.",
      verify_error: "Ugyldig kode. Prøv igen.",
      trusted_device_error:
        "MFA er aktiveret, men vi kunne ikke huske denne enhed.",
      no_factor:
        "Ingen MFA-faktor fundet. Opsæt to-faktor-godkendelse først.",
      factor_removed: "MFA-faktor fjernet.",
      unenroll_error: "Kunne ikke fjerne MFA-faktor. Prøv igen.",
      demo: {
        stub: "Demo-tilstand: MFA simuleres. Klik fortsæt for at gå videre.",
        continue: "Fortsæt",
      },
    },
    common: {
      activity: "Aktivitet",
      added: "tilføjet",
      copied: "Kopieret!",
      copy: "Kopiér",
      details: "Detaljer",
      last_activity_with_date: "seneste aktivitet %{date}",
      load_more: "Indlæs flere",
      loading: "Indlæser...",
      me: "Mig",
      misc: "Diverse",
      past: "Tidligere",
      read_more: "Læs mere",
      retry: "Prøv igen",
      show_less: "Vis mindre",
      task_count: "%{smart_count} opgave |||| %{smart_count} opgaver",
    },
    config: {
      company_sectors: {
        "communication-services": "Kommunikationstjenester",
        "consumer-discretionary": "Cyklisk forbrug",
        "consumer-staples": "Basale forbrugsvarer",
        energy: "Energi",
        financials: "Finans",
        "health-care": "Sundhed",
        industrials: "Industri",
        "information-technology": "Informationsteknologi",
        materials: "Materialer",
        "real-estate": "Ejendomme",
        utilities: "Forsyning",
      },
      deal_categories: {
        copywriting: "Copywriting",
        other: "Andet",
        "print-project": "Trykprojekt",
        "ui-design": "UI-design",
        "website-design": "Webdesign",
      },
      deal_stages: {
        delayed: "Forsinket",
        "in-negociation": "Under forhandling",
        lost: "Tabt",
        opportunity: "Mulighed",
        "proposal-sent": "Tilbud sendt",
        won: "Vundet",
      },
      note_statuses: {
        cold: "Kold",
        hot: "Varm",
        "in-contract": "Er kunde",
        warm: "Lunken",
      },
      task_types: {
        call: "Opkald",
        demo: "Demo",
        email: "E-mail",
        "follow-up": "Opfølgning",
        lunch: "Frokost",
        meeting: "Møde",
        none: "Ingen",
        ship: "Forsendelse",
        "thank-you": "Tak",
      },
    },
    dashboard: {
      deals_chart: "Kommende aftaleomsætning",
      deals_pipeline: "Aftalepipeline",
      latest_activity: "Seneste aktivitet",
      latest_activity_error: "Fejl ved indlæsning af seneste aktivitet",
      latest_notes: "Mine seneste noter",
      latest_notes_added_ago: "tilføjet %{timeAgo}",
      stepper: {
        install: "Installer Atomic CRM",
        progress: "%{step}/3 fuldført",
        whats_next: "Hvad nu?",
      },
      upcoming_tasks: "Kommende opgaver",
    },
    email_lists: {
      all_categories: "Alle kategorier",
      brand_description: "Mailinglistekontakter for %{brand}.",
      brand_title: "%{brand} kontakter",
      brands: {
        gobo_dk: "Gobo DK",
        gobo_fi: "Gobo FI",
        gobo_light: "Gobo Light Solution",
        gobo_se: "Gobo SE",
        ljusdesign: "Ljusdesign",
      },
      create_contact: "Opret kontakt",
      create_title: "Opret kontakt",
      demo_unavailable: "E-maillister kræver Encharge-konfiguration og er ikke tilgængelige i demo-tilstand.",
      description: "Se og administrer Encharge-nyhedsbrevsabonnementer på tværs af Gobo-brands.",
      edit_title: "Rediger kontakt",
      empty: "Ingen kontakter fundet.",
      exists_prompt: "En kontakt med denne e-mail findes allerede. Opdatér den eksisterende kontakt i stedet?",
      fields: {
        categories: "Kommunikationskategorier",
        company: "Kunde",
        contact_person: "Gobo-kontaktperson",
        email: "E-mail",
        first_name: "Fornavn",
        last_name: "Efternavn",
        phone: "Telefon",
        postcode: "Postnummer",
      },
      loading: "Indlæser...",
      loading_more: "Indlæser flere...",
      match_company: "Match via kunde",
      match_email: "Match via e-mail",
      nav: "E-maillister",
      saving: "Gemmer...",
      search_placeholder: "Søg kontakter...",
      showing_count: "%{count} kontakter på listen",
      title: "E-maillister",
      update_existing: "Opdater eksisterende",
      validation: {
        category_required: "Vælg mindst én kommunikationskategori.",
        required_fields: "Fornavn, efternavn og e-mail er påkrævet.",
      },
      widget_empty: "Ingen nyhedsbrevsabonnementer fundet.",
      widget_no_email: "Tilføj en e-mailadresse for at se listeabonnementer.",
      widget_title: "E-maillister",
    },
    header: {
      import_data: "Importer data",
    },
    image_editor: {
      change: "Skift",
      drop_hint: "Slip en fil for at uploade, eller klik for at vælge.",
      editable_content: "Redigerbart indhold",
      title: "Upload og tilpas billede",
      update_image: "Opdater billede",
    },
    import: {
      action: {
        download_error_report: "Download fejlrapporten",
        import: "Importer",
        import_another: "Importer en anden fil",
      },
      error: {
        unable: "Kunne ikke importere denne fil.",
      },
      idle: {
        description_1: "Du kan importere brugere, kunder, kontakter, noter og opgaver.",
        description_2: "Data skal være i en JSON-fil, der matcher følgende eksempel:",
      },
      status: {
        all_success: "Alle poster blev importeret.",
        complete: "Import fuldført.",
        failed: "Mislykkedes",
        imported: "Importeret",
        in_progress: "Import i gang — forlad ikke denne side.",
        some_failed: "Nogle poster blev ikke importeret.",
        table_caption: "Importstatus",
      },
      title: "Importer data",
    },
    language: "Sprog",
    mobile_nav: {
      close_menu: "Luk",
      mega_menu_title: "Menu",
      my_tasks: "Mine opgaver",
      open_menu: "Åbn menu",
      section_account: "Konto",
      section_main: "Hoved",
    },
    navigation: {
      label: "CRM-navigation",
    },
    profile: {
      inbound: {
        description: "Du kan begynde at sende e-mails til din servers indgående e-mailadresse, f.eks. ved at tilføje den i feltet %{field}. Atomic CRM behandler e-mails og tilføjer noter til de tilhørende kontakter.",
        title: "Indgående e-mail",
      },
      mcp: {
        description: "Brug denne URL til at forbinde din AI-assistent til dine CRM-data via Model Context Protocol (MCP).",
        title: "MCP Server",
      },
      password: {
        change: "Skift adgangskode",
      },
      password_reset_sent: "En nulstillingsmail er sendt til din e-mailadresse",
      record_not_found: "Post ikke fundet",
      title: "Profil",
      update_error: "Der opstod en fejl. Prøv igen",
      updated: "Din profil er opdateret",
    },
    recent_website_activity: {
      demo_unavailable: "Seneste website-aktivitet kræver Leadboxer-konfiguration og er ikke tilgængelig i demo-tilstand.",
      empty: "Ingen seneste website-aktivitet fundet",
      loading: "Indlæser...",
      match_reason: {
        domain: "Match via domæne",
        domain_alias: "Match via domænealias",
        email_domain: "Match via e-maildomæne",
        linkedin: "Match via LinkedIn",
        name: "Match via navn",
      },
      summary: "%{count} besøg · %{visits} sessioner · %{events} sidevisninger (seneste)",
      title: "Seneste website-aktivitet",
    },
    settings: {
      app_title: "Apptitel",
      companies: {
        segments: "Segmenter",
      },
      dark_mode_logo: "Logo til mørk tilstand",
      deals: {
        categories: "Kategorier",
        currency: "Valuta",
        pipeline_help: "Vælg hvilke aftalefaser der skal tælle som pipeline-aftaler.",
        pipeline_statuses: "Pipeline-statusser",
        stages: "Faser",
      },
      light_mode_logo: "Logo til lys tilstand",
      notes: {
        statuses: "Statusser",
      },
      preferences: "Præferencer",
      reset_defaults: "Nulstil til standard",
      save_error: "Kunne ikke gemme konfiguration",
      saved: "Konfiguration gemt",
      saving: "Gemmer...",
      sections: {
        bc_sync: "BC Sync",
        branding: "Branding",
        notifications: "Notifikationer",
      },
      tasks: {
        types: "Typer",
      },
      title: "Indstillinger",
      validation: {
        duplicate: "Dublet %{display_name}: %{items}",
        entities: {
          categories: "kategorier",
          stages: "faser",
        },
        in_use: "Kan ikke fjerne %{display_name}, der stadig bruges af aftaler: %{items}",
        validating: "Validerer…",
      },
    },
    theme: {
      dark: "Mørk",
      label: "Tema",
      light: "Lys",
      system: "System",
    },
    validation: {
      invalid_linkedin_url: "URL skal være fra linkedin.com",
      invalid_url: "Skal være en gyldig URL",
    },
    visitor_insights: {
      brand_description: "Website-besøgsdata for %{brand}.",
      brand_title: "%{brand} besøgsindsigt",
      brands: {
        gobo_dk: "Gobo DK",
        gobo_fi: "Gobo FI",
        gobo_light: "Gobo Light Solution",
        gobo_se: "Gobo SE",
        ljusdesign: "Ljusdesign",
      },
      columns: {
        employees: "Medarbejdere",
        events: "Hændelser",
        industry: "Branche",
        last_activity: "Seneste aktivitet",
        last_channel: "Seneste kanal",
        summary: "Resumé",
        visits: "Besøg",
      },
      demo_unavailable: "Besøgsindsigt kræver Leadboxer-konfiguration og er ikke tilgængelig i demo-tilstand.",
      description: "Se identificerede organisationer, der besøger jeres websites.",
      empty: "Ingen besøgende fundet for denne periode.",
      fields: {
        employees: "Medarbejdere",
        industry: "Branche",
        location: "Placering",
        phone: "Telefon",
        score: "Score",
        tags: "Tags",
        website: "Website",
      },
      loading: "Indlæser...",
      loading_sessions: "Indlæser sessioner...",
      nav: "Besøgsindsigt",
      no_sessions: "Ingen sessioner fundet for dette lead.",
      period: {
        last_24h: "Seneste 24 timer",
        last_30d: "Seneste 30 dage",
        last_3d: "Seneste 3 dage",
        last_7d: "Seneste 7 dage",
      },
      session_events: "Sessionshændelser",
      title: "Besøgsindsigt",
      view_customer: "Vis kunde",
    },
    voice_agent: {
      language: "Stemmesprog",
    },
    bc_environment: {
      label: "Primært BC-miljø",
    },
  },
  resources: {
    campaigns: {
      assignee: {
        required: "Vælg en ansvarlig",
      },
      complete_note: {
        placeholder: "Skriv en note om dette besøg eller opkald…",
        save: "Gem note",
        saved_to_company: "Noten gemmes på kunden: %{name}",
        saved_to_contact: "Noten gemmes på kontakten: %{name}",
        skip: "Afslut uden note",
        success: "Opgave afsluttet",
        title: "Tilføj note til opgave",
      },
      fields: {
        assignee: "Ansvarlig",
        description: "Beskrivelse",
        instructions: "Instruktioner",
        kind: "Opgavetype",
        name: "Navn",
        product_name: "Produkt",
        status: "Status",
        targets: "Mål",
        title: "Titel",
      },
      generate: {
        action: "Generér opgaver",
        confirm: "Generér",
        created: "Oprettet",
        deleted: "Fjernet",
        fallback: "Reserve-sælger",
        fallback_help: "Vælg en reserve-sælger for mål uden tildelt sælger.",
        missing: "Sprunget over (ingen sælger)",
        reconcile: "Afstem opgaver",
        skipped: "Sprunget over",
        success: "Opgaver genereret",
      },
      kinds: {
        follow_up: "Opfølgning",
        meeting: "Møde",
        newsletter: "Send nyhedsbrev",
        personal_task: "Personlig opgave",
        phone_call: "Telefonopkald",
        send_info: "Send produktinfo",
        send_samples: "Send prøver",
        visit_demo: "Besøg og demo",
      },
      metadata: {
        materials: "Materialer der skal sendes",
        meeting_format: "Mødeformat (in_person eller online)",
        newsletter_subject: "Emne for nyhedsbrev",
        notes: "Noter",
        product_to_demo: "Produkt til demo",
        sample_description: "Prøvebeskrivelse",
        talk_points: "Samtaleemner",
      },
      name: "Kampagne |||| Kampagner",
      open_tasks: {
        all_completed: "Alle opgaver afsluttet.",
        campaign_task: "Kampagneopgave",
        company_fallback: "Kunde #%{id}",
        contact_fallback: "Kontakt #%{id}",
        show_completed: "Vis afsluttede",
        title: "Opgaver",
      },
      progress: {
        label: "Fremskridt",
        overdue_count: "%{count} forfaldne",
      },
      status: {
        active: "Aktiv",
        completed: "Afsluttet",
        draft: "Kladde",
        open: "Åben",
        overdue: "Forfalden",
        snoozed: "Udsat",
      },
      tabs: {
        definitions: "Opgavedefinitioner",
        my_tasks: "Mine opgaver",
        overview: "Overblik",
      },
      targets: {
        add: "Tilføj mål",
        required: "Tilføj mindst ét mål",
      },
      task_definitions: {
        add: "Tilføj opgavedefinition",
        edit: "Rediger opgavedefinition",
        empty: "Ingen opgavedefinitioner endnu.",
        generated: "Genereret",
        targets: "mål",
      },
    },
    companies: {
      action: {
        create: "Opret kunde",
        edit: "Rediger kunde",
        new: "Ny kunde",
        show: "Vis kunde",
      },
      added_on: "Tilføjet %{date}",
      autocomplete: {
        create_error: "Der opstod en fejl under oprettelse af kunden",
        create_item: "Opret %{item}",
        create_label: "Begynd at skrive for at oprette en ny kunde",
      },
      empty: {
        bc_sync_description: "Kunder synkroniseres fra Business Central. Gå til Indstillinger → BC Sync, eller vent på den natlige synkronisering.",
        description: "Det ser ud til, at din kundeliste er tom.",
        title: "Ingen kunder fundet",
      },
      field_categories: {
        additional_info: "Yderligere oplysninger",
        address: "Adresse",
        contact: "Kontakt",
        context: "Kontekst",
      },
      fields: {
        address: "Adresse",
        city: "By",
        context_links: "Kontekstlinks",
        country: "Land",
        created_at: "Oprettet",
        description: "Beskrivelse",
        linkedin_url: "LinkedIn URL",
        name: "Kundenavn",
        nb_contacts: "Antal kontakter",
        phone_number: "Telefonnummer",
        revenue: "Omsætning",
        sales_id: "Kontoansvarlig",
        sector: "Segment",
        segments: "Segmenter",
        size: "Størrelse",
        state_abbr: "Region",
        tax_identifier: "CVR-nummer",
        website: "Website",
        zipcode: "Postnummer",
      },
      filters: {
        only_mine: "Kun kunder jeg administrerer",
      },
      followed_by: "Sælger: %{name}",
      followed_by_you: "Sælger: dig",
      forcedCaseName: "Kunde",
      name: "Kunde |||| Kunder",
      nb_contacts: "%{smart_count} kontakt |||| %{smart_count} kontakter",
      nb_deals: "%{smart_count} aftale |||| %{smart_count} aftaler",
      no_contacts: "Ingen kontakt",
      sizes: {
        fifty_to_two_hundred_forty_nine_employees: "50-249 medarbejdere",
        one_employee: "1 medarbejder",
        ten_to_forty_nine_employees: "10-49 medarbejdere",
        two_hundred_fifty_or_more_employees: "250 eller flere medarbejdere",
        two_to_nine_employees: "2-9 medarbejdere",
      },
    },
    contacts: {
      action: {
        add: "Tilføj kontakt",
        add_first: "Tilføj din første kontakt",
        browse_synced: "Gennemse synkroniserede kontakter",
        create: "Opret kontakt",
        edit: "Rediger kontakt",
        export_vcard: "Eksporter til vCard",
        new: "Ny kontakt",
        show: "Vis kontakt",
      },
      background: {
        added_on: "Tilføjet %{date}",
        followed_by: "Sælger: %{name}",
        followed_by_you: "Sælger: dig",
        last_activity_on: "Seneste aktivitet %{date}",
        status_none: "Ingen",
      },
      bulk_tag: {
        action: "Tag",
        back: "Tilbage til tags",
        create_description: "Opret et nyt tag og anvend det på de valgte kontakter.",
        description: "Vælg et eksisterende tag, eller opret et nyt til de valgte kontakter.",
        empty: "Ingen tags endnu. Opret et for at tagge de valgte kontakter.",
        error: "Kunne ikke tilføje tag til kontakter",
        noop: "Valgte kontakter har allerede dette tag",
        success: "Tag tilføjet til %{smart_count} kontakt |||| Tag tilføjet til %{smart_count} kontakter",
        title: "Tilføj tag til kontakter",
      },
      empty: {
        bc_sync_description: "Kontakter synkroniseres fra Business Central. Gå til Indstillinger → BC Sync, eller vent på den natlige synkronisering.",
        description: "Det ser ud til, at din kontaktliste er tom.",
        title: "Ingen kontakter fundet",
      },
      field_categories: {
        background_info: "Baggrund",
        identity: "Identitet",
        misc: "Diverse",
        personal_info: "Personlige oplysninger",
        position: "Stilling",
      },
      fields: {
        background: "Baggrund (bio, hvordan I mødtes osv.)",
        company_id: "Kunde",
        email: "E-mail",
        email_jsonb: "E-mailadresser",
        first_name: "Fornavn",
        has_newsletter: "Har nyhedsbrev",
        last_name: "Efternavn",
        last_seen: "Sidst set",
        linkedin_url: "LinkedIn URL",
        phone_jsonb: "Telefonnumre",
        phone_number: "Telefonnummer",
        sales_id: "Kontoansvarlig",
        title: "Titel",
      },
      filters: {
        before_last_month: "Før sidste måned",
        before_this_month: "Før denne måned",
        before_this_week: "Før denne uge",
        managed_by_me: "Administreret af mig",
        search: "Søg navn, kunde...",
        tags: "Tags",
        tasks: "Opgaver",
        this_week: "Denne uge",
        today: "I dag",
      },
      forcedCaseName: "Kontakt",
      hot: {
        empty_change_status: "Skift en kontakts status ved at tilføje en note til kontakten og klikke på \"vis muligheder\".",
        empty_hint: "Kontakter med status \"Varm\" vises her.",
        title: "Varme kontakter",
      },
      import: {
        button: "Importer CSV",
        complete: "Kontaktimport fuldført. Importerede %{importCount} kontakter med %{errorCount} fejl",
        contacts_label: "kontakt |||| kontakter",
        csv_file: "CSV-fil",
        error: "Kunne ikke importere denne fil. Kontrollér, at du har angivet en gyldig CSV-fil.",
        imported: "Importeret",
        progress: "Importerede %{importCount} / %{rowCount} kontakter med %{errorCount} fejl.",
        remaining_time: "Estimeret resterende tid:",
        running: "Importen kører — luk ikke denne fane.",
        sample_download: "Download CSV-eksempel",
        sample_hint: "Her er et CSV-eksempel, du kan bruge som skabelon",
        stop: "Stop import",
        title: "Importer kontakter",
      },
      inputs: {
        genders: {
          female: "Hun/Hende",
          male: "Han/Ham",
          nonbinary: "De/Dem",
        },
        personal_info_types: {
          home: "Privat",
          other: "Andet",
          work: "Arbejde",
        },
      },
      list: {
        error_loading: "Fejl ved indlæsning af kontakter",
      },
      merge: {
        action: "Flet med en anden kontakt",
        confirm: "Flet kontakter",
        current_contact: "Nuværende kontakt (slettes)",
        description: "Flet denne kontakt med en anden.",
        error: "Kunne ikke flette kontakter",
        merging: "Fletter...",
        no_additional_data: "Ingen yderligere data at flette",
        select_target: "Vælg en kontakt at flette med",
        success: "Kontakter flettet",
        target_contact: "Målkontakt (beholdes)",
        title: "Flet kontakt",
        warning_description: "Alle data overføres til den anden kontakt. Handlingen kan ikke fortrydes.",
        warning_title: "Advarsel: Destruktiv handling",
        what_will_be_merged: "Dette flettes:",
      },
      name: "Kontakt |||| Kontakter",
      position_at: "%{title} hos",
      position_at_company: "%{title} hos %{company}",
      part_of_company: "Del af %{name}",
      open_company: "Åbn kunde",
    },
    deals: {
      action: {
        back_to_deal: "Tilbage til aftale",
        create: "Opret aftale",
        new: "Ny aftale",
      },
      archived: {
        action: "Arkivér",
        error: "Fejl: aftale ikke arkiveret",
        list_title: "Arkiverede aftaler",
        success: "Aftale arkiveret",
        title: "Arkiveret aftale",
        view: "Vis arkiverede aftaler",
      },
      empty: {
        before_create: "før du opretter en aftale.",
        description: "Det ser ud til, at din aftaleliste er tom.",
        title: "Ingen aftaler fundet",
      },
      field_categories: {
        misc: "Diverse",
      },
      fields: {
        amount: "Budget",
        category: "Kategori",
        company_id: "Kunde",
        contact_ids: "Kontakter",
        description: "Beskrivelse",
        expected_closing_date: "Forventet lukkedato",
        name: "Navn",
        stage: "Fase",
      },
      inputs: {
        linked_to: "Knyttet til",
      },
      invalid_date: "Ugyldig dato",
      name: "Aftale |||| Aftaler",
      unarchived: {
        action: "Send tilbage til tavlen",
        error: "Fejl: aftale ikke gendannet",
        success: "Aftale gendannet",
      },
      updated: "Aftale opdateret",
    },
    notes: {
      action: {
        add: "Tilføj note",
        add_first: "Tilføj din første note",
        add_this: "Tilføj denne note",
        delete: "Slet note",
        edit: "Rediger note",
        update: "Opdater note",
      },
      actions: {
        attach_document: "Vedhæft dokument",
      },
      added: "Note tilføjet",
      author_added: "%{name} tilføjede en note",
      deleted: "Note slettet",
      empty: "Ingen noter endnu",
      fields: {
        attachments: "Vedhæftninger",
        contact_id: "Kontakt",
        date: "Dato",
        deal_id: "Aftale",
        status: "Status",
      },
      forcedCaseName: "Note",
      inputs: {
        add_note: "Tilføj en note",
        options_hint: "(vedhæft filer eller ændr detaljer)",
        show_options: "Vis muligheder",
      },
      list: {
        error_loading: "Fejl ved indlæsning af noter",
      },
      me: "Mig",
      name: "Note |||| Noter",
      note_for_contact: "Note til %{name}",
      sheet: {
        create: "Opret note",
        create_for: "Opret note for %{name}",
        edit: "Rediger note",
        edit_for: "Rediger note for %{name}",
      },
      stepper: {
        hint: "Gå til en kontaktside og tilføj en note",
      },
      validation: {
        note_or_attachment_required: "En note eller vedhæftning er påkrævet",
      },
      you_added: "Du tilføjede en note",
    },
    sales: {
      action: {
        new: "Ny bruger",
      },
      create: {
        error: "Der opstod en fejl under oprettelse af brugeren.",
        success: "Bruger oprettet. Vedkommende modtager snart en e-mail for at angive adgangskode.",
        title: "Opret ny bruger",
      },
      edit: {
        error: "Der opstod en fejl. Prøv igen.",
        record_not_found: "Post ikke fundet",
        success: "Bruger opdateret",
        title: "Rediger %{name}",
      },
      fields: {
        administrator: "Admin",
        disabled: "Deaktiveret",
        email: "E-mail",
        first_name: "Fornavn",
        last_name: "Efternavn",
      },
      name: "Bruger |||| Brugere",
    },
    tags: {
      action: {
        add: "Tilføj tag",
        create: "Opret nyt tag",
      },
      dialog: {
        color: "Farve",
        create_title: "Opret nyt tag",
        edit_title: "Rediger tag",
        name_label: "Tag-navn",
        name_placeholder: "Indtast tag-navn",
      },
      name: "Tag |||| Tags",
    },
    tasks: {
      action: {
        add: "Tilføj opgave",
        create: "Opret opgave",
        edit: "Rediger opgave",
      },
      actions: {
        postpone_next_week: "Udskyd til næste uge",
        postpone_tomorrow: "Udskyd til i morgen",
        title: "opgavehandlinger",
      },
      added: "Opgave tilføjet",
      deleted: "Opgave slettet",
      dialog: {
        create: "Opret opgave",
        create_for: "Opret opgave for %{name}",
      },
      empty: "Ingen opgaver endnu",
      empty_list_hint: "Opgaver tilføjet til dine kontakter vises her.",
      fields: {
        contact_id: "Kontakt",
        due_date: "Forfaldsdato",
        due_short: "forfalder",
        text: "Beskrivelse",
        type: "Type",
      },
      filters: {
        campaign_tasks: "Kun kampagneopgaver",
        later: "Senere",
        overdue: "Forfalden",
        this_week: "Denne uge",
        today: "I dag",
        tomorrow: "I morgen",
        with_pending: "Med ventende opgaver",
      },
      forcedCaseName: "Opgave",
      name: "Opgave |||| Opgaver",
      recurrence: {
        badge: "Gentagende",
        custom: "Tilpasset",
        days: "Dage",
        enabled: "Gentagende opgave",
        end_date: "Slutdato",
        every_count: "Interval",
        every_count_help: "Brug 1 for hvert interval, eller højere for hver N. periode.",
        every_day: "Hver dag",
        every_month: "Hver måned",
        every_unit: "Enhed",
        every_week: "Hver uge",
        every_year: "Hvert år",
        has_end_date: "Angiv slutdato",
        months: "Måneder",
        weeks: "Uger",
        years: "År",
      },
      regarding_company: "(Vedr.: %{name})",
      regarding_contact: "(Vedr.: %{name})",
      sheet: {
        edit: "Rediger opgave",
        edit_for: "Rediger opgave for %{name}",
      },
      updated: "Opgave opdateret",
    },
  },
};

